module.exports = "<svg width=\"15\" height=\"24\" viewBox=\"0 0 15 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.171 0L7 0.560846V16.8353L7.171 17L15 12.5346L7.171 0Z\" fill=\"#343434\"></path><path d=\"M7 0L0 12.5346L7 17V9.1009V0Z\" fill=\"#8C8C8C\"></path><path d=\"M7.09721 18.1926L7 18.299V23.7449L7.09721 24L15 14L7.09721 18.1926Z\" fill=\"#3C3C3B\"></path><path d=\"M7 24V18.1925L0 14L7 24Z\" fill=\"#8C8C8C\"></path><path d=\"M7 17L15 12.4776L7 9V17Z\" fill=\"#141414\"></path><path d=\"M0 12.4775L7 17V9L0 12.4775Z\" fill=\"#393939\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/ethereum.svg
// module id = 862
// module chunks = 0